// Sport Energy Svedtest — beregner + natrium-screening (Fase 4.9.2 — 'normal' vejr er nu standardvalget: et gyldigt svar, men det gemmer ingen vejr-kontekst og giver den neutrale gentag-note, fordi 'normalt' ikke peger et bestemt sted hen. Tidligere: 4.9.1 — varmere coach-tone i salt-resultatet: kicker, note og banner skrevet om uden klinisk sprog og uden bindestreger. Tidligere: 4.9.0 — vejr-kontekst: vejret under passet gemmes med tallet, gentag-noten goeres konkret, badges baeres af introteksten)
// Tidligere: Sport Energy Svedtest — beregning + side-UI (Fase 4.8.0)
//
// FASE 4.8.0 (jun 2026): Natrium-screeningen omskrevet efter
// litteraturen (Precision Hydration/Andy Blow, STYRKR, HSS). Svedens
// salt kan ikke måles hjemme, men tegnene er velbeskrevne — og de er
// IKKE lige meget værd:
//   • Smag (salt på læber) og sviende øjne er PRIMÆRE tegn: de måler
//     koncentration. Vægt ×2.
//   • Saltrande/krystaller er SEKUNDÆRT: en høj svedrate alene kan
//     give hvide mærker uden at sveden er særlig salt (Andy Blow).
//     Vægt ×1, med en ærlig note ved spørgsmålet.
//   • Salttrang er et understøttende tegn. Vægt ×1.
//   • Kramper er FJERNET fra point-summen — moderne sportsfysiologi
//     forbinder dem oftere med neuromuskulær træthed end med natrium.
//     De bruges kun som tie-breaker: ved en grænse-score løfter
//     'ofte kramper' ét niveau, men kan aldrig stå alene.
// Niveauer (sigter mod fordelingen 200–2000 mg/L, snit ~800–1000):
//   lav 450 · normal 700 · salt 1000. Ren funktion, testes i node.
//
// FASE 4.7.0 (jun 2026): Natrium-screening — svedens salt kan ikke
// måles hjemme, men den kan screenes ud fra kendte tegn: saltrande,
// sviende/salt sved, kramper og salttrang. Fire spørgsmål (0/1/2
// point) klassificerer i guidens tre niveauer: 0–1 → lav (450 mg/L),
// 2–5 → normal (650), 6–8 → salt (1000). Ren funktion
// (computeSodium) testes i node; resultatet gemmes i profilen og
// forudvælges af race-kittet. Tegn, ikke laboratorium — og det
// siger resultatet åbent.
//
// FASE 4.6.0 (jun 2026): Den røde tråd fra race-kit — resultatet
// bærer hero-fliser (mistet i alt, erstat pr. time), noterne er
// ikon-noter (rk-note), og entré-animationen kører kun ved FØRSTE
// beregning. compute() er urørt.
//
// Guidet vejning-før/efter-flow. Beregningen ligger som ren funktion
// (window.SportEnergySvedtest.compute) så den kan testes i node —
// samme princip som rules-motoren. Resultatet gemmes i atlet-profilen
// (sport-energy-profile.js) og læses derfra af guiden ved næste besøg.
//
// Matematik: svedtab = vægttab (kg → ml) + drukket undervejs.
// Per time = total / (minutter/60), rundet til nærmeste 50.
// Guiden arbejder med 400–2500 ml/t (sliderens spænd) — tal udenfor
// vises ærligt, og der gemmes nærmeste grænse med tydelig besked.

(function () {
  'use strict';

  function num(v) {
    if (typeof v === 'number') return v;
    if (typeof v !== 'string') return NaN;
    return parseFloat(v.replace(',', '.'));
  }

  function compute(input) {
    input = input || {};
    var before = num(input.beforeKg);
    var after = num(input.afterKg);
    var drank = num(input.drankMl);
    var minutes = num(input.minutes);

    if (isNaN(before) || before < 30 || before > 200) {
      return { ok: false, field: 'before',
        error: 'Vægt før skal være mellem 30 og 200 kg.' };
    }
    if (isNaN(after) || after < 30 || after > 200) {
      return { ok: false, field: 'after',
        error: 'Vægt efter skal være mellem 30 og 200 kg.' };
    }
    if (isNaN(drank) || drank < 0 || drank > 5000) {
      return { ok: false, field: 'drank',
        error: 'Drukket undervejs skal være mellem 0 og 5000 ml. Skriv 0 hvis du ikke drak.' };
    }
    if (isNaN(minutes) || minutes < 20 || minutes > 360) {
      return { ok: false, field: 'minutes',
        error: 'Varigheden skal være mellem 20 minutter og 6 timer — og mindst en time giver det mest pålidelige tal.' };
    }

    var totalMl = Math.round((before - after) * 1000 + drank);
    if (totalMl <= 0) {
      return { ok: false, field: null,
        error: 'Tallene giver et negativt svedtab. Tjek om vægtene er byttet om, eller om der er drukket mere end noteret.' };
    }

    var perHourMl = Math.round(totalMl / (minutes / 60) / 50) * 50;
    var belowRange = perHourMl < 400;
    var aboveRange = perHourMl > 2500;
    var saveMl = Math.min(2500, Math.max(400, perHourMl));

    return {
      ok: true,
      totalMl: totalMl,
      perHourMl: perHourMl,
      saveMl: saveMl,
      belowRange: belowRange,
      aboveRange: aboveRange,
      // 65–85 % erstattes undervejs — samme bånd som guidens
      // getHydrationTarget, rundet til 50.
      replaceMinMl: Math.round(saveMl * 0.65 / 50) * 50,
      replaceMaxMl: Math.round(saveMl * 0.85 / 50) * 50
    };
  }

  // ── Natrium-screening (Fase 4.8.0) — vægtede tegn, ren motor ──
  var SODIUM_LEVELS = {
    lav:    { mgPerL: 450,  per500: 225, label: 'Lav',    saltPhrase: 'kun let salt' },
    normal: { mgPerL: 700,  per500: 350, label: 'Normal', saltPhrase: 'middel salt' },
    salt:   { mgPerL: 1000, per500: 500, label: 'Høj',    saltPhrase: 'meget salt' }
  };
  // Vægte: primær-tegn (smag, øjne) tæller dobbelt; saltrande og
  // salttrang enkelt. Hvert tegn svares 0 (nej) / 1 (nogle gange) /
  // 2 (ja), så maks vægtet score = (2+2+1+1)·2 = 12.
  var NA_WEIGHTS = { taste: 2, sting: 2, streaks: 1, craving: 1 };
  function computeSodium(input) {
    input = input || {};
    var keys = ['taste', 'sting', 'streaks', 'craving'];
    var score = 0, maxScore = 0;
    for (var i = 0; i < keys.length; i++) {
      var w = NA_WEIGHTS[keys[i]];
      maxScore += 2 * w;
      var v = num(input[keys[i]]);
      if (isNaN(v) || v < 0 || v > 2) {
        return { ok: false, error: 'Svar på alle fire tegn-spørgsmål først.' };
      }
      score += v * w;
    }
    // Kramper er tie-breaker, ikke point: 0/1/2 = aldrig/sjældent/ofte.
    // 'ofte' (2) løfter ét niveau ved en grænse-score, aldrig alene.
    var crampsRaw = num(input.cramps);
    var cramps = (isNaN(crampsRaw) ? 0 : Math.max(0, Math.min(2, crampsRaw)));

    // Grænser på den vægtede 0–12-skala: 0–3 lav · 4–7 normal · 8+ salt.
    var level;
    if (score >= 8) level = 'salt';
    else if (score >= 4) level = 'normal';
    else level = 'lav';

    // Tie-breaker: ofte kramper løfter ét niveau, men kun når scoren
    // ligger i den øverste tredjedel af sit nuværende bånd (reel tvivl).
    var bumped = false;
    if (cramps === 2) {
      if (level === 'lav' && score >= 2) { level = 'normal'; bumped = true; }
      else if (level === 'normal' && score >= 6) { level = 'salt'; bumped = true; }
    }

    var L = SODIUM_LEVELS[level];
    return {
      ok: true, score: score, maxScore: maxScore,
      level: level, mgPerL: L.mgPerL, per500: L.per500, label: L.label, saltPhrase: L.saltPhrase,
      cramps: cramps, bumped: bumped
    };
  }

  window.SportEnergySvedtest = { compute: compute, computeSodium: computeSodium };

  // ── Side-UI ─────────────────────────────────────────────
  if (typeof document === 'undefined') return;

  function $(id) { return document.getElementById(id); }
  function track(name, props) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', name);
      if (props) {
        for (var k in props) {
          if (Object.prototype.hasOwnProperty.call(props, k) && props[k] != null) {
            window.clarity('set', 'svedtest_' + k, String(props[k]));
          }
        }
      }
    } catch (e) {}
  }

  function fmtBottles(minMl, maxMl) {
    function half(x) { return Math.round(x / 500 * 2) / 2; }
    var a = half(minMl), b = half(maxMl);
    function fmt(n) { return ('' + n).replace('.', ','); }
    var range = a === b ? fmt(a) : fmt(a) + '–' + fmt(b);
    return range + (b <= 1 ? ' flaske' : ' flasker') + ' (500 ml) i timen';
  }

  var lastResult = null;

  // ── Designsystem (delt sprog med race-kit): ikoner, fliser, noter ──
  var SEI = {
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5s5.5 6.1 5.5 10a5.5 5.5 0 1 1-11 0c0-3.9 5.5-10 5.5-10z"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2.5 4.8 13.4h6L9.6 21.5l8.6-11.1h-6L13 2.5z"/></svg>',
    recover: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v4.3h-4.3"/></svg>'
  };
  function statTile(v, l) { return '<div class="rk-stat"><span class="rk-stat-v">' + v + '</span><span class="rk-stat-l">' + l + '</span></div>'; }
  function noteRow(ico, inner, warn) {
    return '<div class="rk-note' + (warn ? ' rk-note-warn' : '') + '">'
      + '<span class="rk-note-ico">' + ico + '</span><p>' + inner + '</p></div>';
  }


  function renderSavedBanner() {
    var el = $('sv-saved-banner');
    if (!el) return;
    var P = window.SportEnergyProfile;
    var ml = P ? P.getSweatRate() : null;
    var pr = P && P.get ? P.get() : null;
    var cond = pr && WEATHER[pr.sweatConditions] ? WEATHER[pr.sweatConditions] : null;
    var na = P && P.getSodium ? P.getSodium() : null;
    var naL = na && SODIUM_LEVELS[na] ? SODIUM_LEVELS[na] : null;
    var html = '';
    if (ml) {
      html += '<div class="sv-banner">'
        + '<span>Din profil har et målt svedtab på <strong>' + ml + ' ml i timen</strong>'
        + (cond ? ' — målt i ' + cond.label : '') + '. Guiden bruger det automatisk.</span>'
        + '<button type="button" class="sv-delete" onclick="SVT.deleteSaved()">Slet det gemte tal</button>'
        + '</div>';
    }
    if (naL) {
      html += '<div class="sv-banner">'
        + '<span>Din sved er <strong>' + naL.saltPhrase + ' (cirka ' + naL.mgPerL + ' mg salt pr. liter)</strong>. Race-kittet bruger det automatisk.</span>'
        + '<button type="button" class="sv-delete" onclick="SVT.deleteSodium()">Slet screeningen</button>'
        + '</div>';
    }
    el.innerHTML = html;
  }

  // FASE 4.9.0: vejr-kontekst. Vejret aendrer ikke beregningen —
  // testen maaler det faktiske tab; vejret forklarer det. Det gemmes
  // med tallet og goer gentag-noten konkret.
  var WEATHER = {
    koldt:   { label: 'koldt vejr',        again: 'i varmere forhold' },
    koeligt: { label: 'morgenkøligt vejr', again: 'på en varm dag' }, // udgået af UI; bevaret for gamle profiler
    varmt:   { label: 'varmt vejr',        again: 'i køligere forhold' }
  };
  // 'normal' er et gyldigt svar, men bærer ingen kontekst: et normalt
  // pas peger ikke et bestemt sted hen, så vi hverken gemmer det eller
  // skriver en retnings-note. weatherChoice returnerer derfor null for
  // 'normal' — det giver automatisk den neutrale gentag-note.
  function weatherChoice() {
    var el = document.querySelector('input[name="sv-weather"]:checked');
    if (!el || el.value === 'normal') return null;
    return WEATHER[el.value] ? el.value : null;
  }

  function calc() {
    var res = compute({
      beforeKg: $('sv-before').value,
      afterKg: $('sv-after').value,
      drankMl: $('sv-drank').value,
      minutes: $('sv-min').value
    });
    var out = $('sv-result');
    if (!out) return;
    if (!res.ok) {
      lastResult = null;
      out.innerHTML = '<div class="sv-error">' + res.error + '</div>';
      return;
    }
    lastResult = res;
    lastResult.conditions = weatherChoice();
    track('svedtest_computed', { per_hour: res.perHourMl, weather: lastResult.conditions });

    var liter = ('' + (Math.round(res.totalMl / 100) / 10)).replace('.', ',');
    // FASE 4.5.0 (Bevel-læren): tallet får en tilstand og en placering
    // på skalaen — et tal alene siger ikke atleten, hvor de står.
    var state = res.perHourMl < 800 ? 'I den lave ende'
      : res.perHourMl < 1200 ? 'Moderat' : 'Højt';
    var pos = Math.min(100, Math.max(0, (Math.min(2500, Math.max(400, res.perHourMl)) - 400) / 2100 * 100));
    // FASE 4.6.0: sv-pop kun når kortet er nyt — en genberegning er
    // ikke en entré.
    var isFirst = !out.querySelector('.sv-result-card');
    var html = '<div class="sv-result-card' + (isFirst ? ' sv-pop' : '') + '">'
      + '<div class="sv-result-kicker">Dit svedtab · ' + state + '</div>'
      + '<div class="sv-result-number"><span id="sv-count" data-target="' + res.perHourMl + '">' + res.perHourMl + '</span> <span>ml i timen</span></div>'
      + '<div class="sv-scale" aria-hidden="true"><div class="sv-scale-track">'
      + '<span class="sv-scale-marker" style="left:' + pos.toFixed(1) + '%"></span></div>'
      + '<div class="sv-scale-labels"><span>Lav</span><span>Moderat</span><span>Høj</span></div></div>'
      + '<div class="rk-stats">'
      + statTile(liter + ' L', 'mistet på passet')
      + statTile(res.replaceMinMl + '–' + res.replaceMaxMl, 'erstat pr. time (ml)')
      + '</div>'
      + '<p class="sv-result-line">Vi sigter mod at erstatte 65–85 % undervejs — for dig cirka '
      + fmtBottles(res.replaceMinMl, res.replaceMaxMl) + '.</p>';
    if (res.belowRange) {
      html += noteRow(SEI.drop, 'Tallet ligger under det spænd, guiden arbejder med (400–2500 ml/t). Gemmer du, regner guiden med 400 ml/t.');
    }
    if (res.aboveRange) {
      html += noteRow(SEI.drop, 'Tallet ligger over det spænd, guiden arbejder med (400–2500 ml/t). Gemmer du, regner guiden med 2500 ml/t — og så er det værd at gentage testen for at være sikker.', true);
    }
    var w = lastResult.conditions ? WEATHER[lastResult.conditions] : null;
    html += noteRow(SEI.drop, w
      ? 'Målt i ' + w.label + ' — tallet gælder den slags dag. Mål gerne igen ' + w.again + ', så du kender dit spænd.'
      : 'Tallet gælder forhold som dem, du testede under — varme og intensitet flytter det. Mål gerne igen på en anden slags dag.')
      + '<div class="sv-actions">'
      + '<button type="button" class="sv-save" id="sv-save" onclick="SVT.save()">Gem i min profil</button>'
      + '</div></div>';
    out.innerHTML = html;
    countUp();
  }

  // FASE 4.5.0: Tallet tæller op — en måling, ikke en tekstopdatering.
  // Respekterer prefers-reduced-motion.
  function countUp() {
    var el = $('sv-count');
    if (!el || !window.requestAnimationFrame) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = parseInt(el.getAttribute('data-target'), 10);
    if (!target) return;
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / 700);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased / 50) * 50;
      if (p < 1) requestAnimationFrame(step); else el.textContent = target;
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function save() {
    if (!lastResult || !lastResult.ok) return;
    var ok = window.SportEnergyProfile
      ? window.SportEnergyProfile.setSweatRate(lastResult.saveMl, 'test', lastResult.conditions)
      : false;
    var btn = $('sv-save');
    track('svedtest_saved', { ml: lastResult.saveMl, weather: lastResult.conditions, ok: ok });
    if (!ok) {
      if (btn) btn.textContent = 'Kunne ikke gemme — tjek at browseren tillader lokal lagring';
      return;
    }
    var actions = btn && btn.parentElement;
    if (actions) {
      actions.innerHTML = '<div class="sv-saved-confirm">Gemt. Guiden bruger nu dit målte tal.</div>'
        + '<a class="sv-cta" href="/pages/find-dine-produkter">Åbn guiden med dit tal →</a>';
    }
    renderSavedBanner();
  }

  function deleteSaved() {
    if (window.SportEnergyProfile) window.SportEnergyProfile.clearSweatRate();
    track('svedtest_deleted');
    renderSavedBanner();
  }

  // ── Natrium-screening: UI ──
  var lastSodium = null;
  function naAnswer(name) {
    var r = document.querySelector('input[name="' + name + '"]:checked');
    return r ? r.value : NaN;
  }
  function sodium() {
    var out = $('na-result');
    if (!out) return;
    var res = computeSodium({
      taste: naAnswer('na-q1'),    // primær (×2)
      sting: naAnswer('na-q2'),    // primær (×2)
      streaks: naAnswer('na-q3'),  // sekundær (×1)
      craving: naAnswer('na-q4'),  // sekundær (×1)
      cramps: naAnswer('na-q5')    // tie-breaker
    });
    if (!res.ok) { lastSodium = null; out.innerHTML = '<div class="sv-error">' + res.error + '</div>'; return; }
    lastSodium = res;
    track('natrium_computed', { level: res.level });
    // Samme resultat-sprog som svedtabet: tilstand, stort tal,
    // placering på skalaen, fliser, ikon-note. sv-pop kun første gang.
    var pos = res.level === 'lav' ? 12 : res.level === 'salt' ? 88 : 50;
    var isFirst = !out.querySelector('.sv-result-card');
    out.innerHTML = '<div class="sv-result-card' + (isFirst ? ' sv-pop' : '') + '">'
      + '<div class="sv-result-kicker">Din sved er ' + res.saltPhrase + '</div>'
      + '<div class="sv-result-number">' + res.mgPerL + ' <span>mg pr. liter sved</span></div>'
      + '<div class="sv-scale" aria-hidden="true"><div class="sv-scale-track">'
      + '<span class="sv-scale-marker" style="left:' + pos + '%"></span></div>'
      + '<div class="sv-scale-labels"><span>Lav</span><span>Normal</span><span>Høj</span></div></div>'
      + '<div class="rk-stats">'
      + statTile('≈' + res.per500, 'mg pr. 500 ml flaske')
      + statTile(res.score + ' af ' + res.maxScore, 'vægtet tegn-score')
      + '</div>'
      + (res.bumped ? noteRow(SEI.drop, 'Dine svar lå på grænsen, og hyppige kramper trak dig ét niveau op — kramper alene afgør intet, men sammen med de øvrige tegn peger de opad.') : '')
      + noteRow(SEI.drop, 'Det her er et kvalificeret bud ud fra dine tegn, ikke en laboratorieprøve. Smagen og sviende øjne tæller mest, fordi de følger saltet bedst. Race-kittet bruger dit svar automatisk, og du kan altid justere det for en bestemt løbsdag. Vil du være helt sikker, kan en rigtig svedtest hos en fysiolog give dig det præcise tal.')
      + '<div class="sv-actions">'
      + '<button type="button" class="sv-save" id="na-save" onclick="SVT.saveSodium()">Gem i min profil</button>'
      + '</div></div>';
  }
  function saveSodium() {
    if (!lastSodium || !lastSodium.ok) return;
    var ok = window.SportEnergyProfile && window.SportEnergyProfile.setSodium
      ? window.SportEnergyProfile.setSodium(lastSodium.level) : false;
    var btn = $('na-save');
    track('natrium_saved', { level: lastSodium.level, ok: ok });
    if (!ok) {
      if (btn) btn.textContent = 'Kunne ikke gemme — tjek at browseren tillader lokal lagring';
      return;
    }
    var actions = btn && btn.parentElement;
    if (actions) {
      actions.innerHTML = '<div class="sv-saved-confirm">Gemt. Race-kittet forudvælger nu dit niveau.</div>'
        + '<a class="sv-cta" href="/pages/race-kit">Åbn race-kittet →</a>';
    }
    renderSavedBanner();
  }
  function deleteSodium() {
    if (window.SportEnergyProfile && window.SportEnergyProfile.setSodium) {
      window.SportEnergyProfile.setSodium(null);
    }
    track('natrium_deleted');
    renderSavedBanner();
  }

  window.SVT = { calc: calc, save: save, deleteSaved: deleteSaved,
    sodium: sodium, saveSodium: saveSodium, deleteSodium: deleteSodium };
  renderSavedBanner();
})();